module.exports = __webpack_public_path__ + "media/entry_pass/conisen_logo-9ecbd951.png";